var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.457,
    height: 161.912,
    viewBox: "0 0 146.457 161.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3238",
    "data-name": "Grupo 3238",
    transform: "translate(-633.543 -346.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6564",
    "data-name": "Trazado 6564",
    d: "M329.513,6.412a68.211,68.211,0,0,1,49.4,20.549,68.666,68.666,0,0,1,20.949,51.025,73.335,73.335,0,0,1-19.988,51.879,64.661,64.661,0,0,1-49.183,21.349A66.717,66.717,0,0,1,281,130.078,69.894,69.894,0,0,1,260.554,79.72a77.4,77.4,0,0,1,5.765-29.862A69.388,69.388,0,0,1,281.69,26.667a71.2,71.2,0,0,1,22.1-14.784A64.049,64.049,0,0,1,329.513,6.412ZM294.553,78.84A36.881,36.881,0,0,0,305.6,106.727a34.159,34.159,0,0,0,49.29.294,36.667,36.667,0,0,0,10.942-27.968,37.068,37.068,0,0,0-11.048-28.075A34.88,34.88,0,0,0,330.1,40.3a34.506,34.506,0,0,0-24.605,10.675A37.042,37.042,0,0,0,294.553,78.84Z",
    transform: "translate(376.001 357.057)",
    fill: "#65c28f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M13.8,7.156c7.62,0,13.8-.978,13.8,6.641A13.8,13.8,0,1,1,0,13.8C0,6.177,6.177,7.156,13.8,7.156Z",
    transform: "translate(698.148 435.336)",
    fill: "#393f4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M334.291,7.871s-9.821,5.151-9.447,14.117c0,0-14.971-.534-12.489,12.116a48.469,48.469,0,0,0-10.034-9.927c9.073-3.549,10.087-13.477,9.927-19.161A4.3,4.3,0,0,1,316.571.559a23.137,23.137,0,0,1,17.72,7.312Z",
    transform: "translate(445.709 347.271)",
    fill: "#65c28f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M289.736,25.135a48.328,48.328,0,0,0-11.075,9.073c3.923-12.543-11.235-13.477-11.235-13.477C268.68,11.845,259.42,5.76,259.42,5.76A23.084,23.084,0,0,1,277.754.209a4.4,4.4,0,0,1,2.989,1.6,4.3,4.3,0,0,1,.881,3.256C280.9,10.67,280.983,20.758,289.736,25.135Z",
    transform: "translate(374.123 346.367)",
    fill: "#65c28f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.72c4c3621e114203282fbffd2d66f2a2.svg";
export { ForwardRef as ReactComponent };